<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="查询"
      permpisionsQuery
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          {
            label: '地址名称',
            value: 'addressName',
            type: 'input',
            placeholder: '请输入地址名称',
          },
          {
            label: '导航地址',
            value: 'addressDetail',
            type: 'input',
            placeholder: '请输入导航地址',
          },
          {
            label: '应到地址',
            value: 'addressShow',
            type: 'input',
            placeholder: '请输入应到地址',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        ...searchBoxData,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
